import { useRef, FunctionComponent, ComponentProps, useState, useEffect } from 'react';
import { ThreeEvent, useFrame } from '@react-three/fiber';
import { Text } from '@react-three/drei';
import { MAX_OPACITY, MIN_OPACITY, PULSE_PERIOD } from '@/lib/globals';
import { oscillate } from '@/lib/mathUtils';

type TextProps = ComponentProps<typeof Text>;

export const BlinkingText: FunctionComponent<TextProps> = (props) => {
    const textRef = useRef<TextProps>();
    const timer = useRef<number>(0);
    const [hovered, setHovered] = useState<boolean>(false);
    const over = (e: ThreeEvent<PointerEvent>): void => {
        e.stopPropagation();
        setHovered(true);
    };
    const out = (): void => {
        setHovered(false);
    };
    useEffect(() => {
        if (hovered) {
            document.body.style.cursor = 'pointer';
        }
        return () => {
            document.body.style.cursor = 'auto';
        };
    }, [hovered]);

    useFrame((_, delta) => {
        timer.current += delta;
        if (textRef.current && textRef.current.fillOpacity !== null && textRef.current.fillOpacity !== undefined) {
            textRef.current.fillOpacity = oscillate(MIN_OPACITY, MAX_OPACITY, timer.current, PULSE_PERIOD);
        }
    });

    return (
        <Text onPointerOver={over} onPointerOut={out} fillOpacity={0} ref={textRef} {...props}>
            {props.children}
        </Text>
    );
};
